import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { TableRow, TableCell, Tooltip, LinearProgress } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import HistoryIcon from '@material-ui/icons/History';
import ReadMoreInline from '../../../shared_elements/components/ReadMoreInline';
import { displayDateFormatShort } from '../../../constants';
import { qmeStatusOptions, qmeTrackerHd, qmeDateTimeFormat } from '../';
import ChipList, { formatComponentSerial } from './ChipList';
const LongText = ({ text }) => <ReadMoreInline text={text} maxLength={60} />;
const Cell = ({ index, children, ...props }) => (
  <TableCell {...props}>
    <div style={{ minWidth: qmeTrackerHd[index].width, maxWidth: qmeTrackerHd[index].width, wordBreak: 'break-word' }}>{children}</div>
  </TableCell>
);
export default function QmeTrackerList({ item, viewQmeTracker, editQmeTracker, viewRevisionHistory }) {
  const status = qmeStatusOptions.find(option => option.id === item.tracker_status?.id);
  return (
    <TableRow hover tabIndex={-1}>
      <Cell index={0} className='actions-cell'>
        <ul className="list-inline" style={{ display: "flex", justifyContent: "left" }}>
          <li className="list-inline-item">
            <Tooltip title="Revision History" arrow>
              <HistoryIcon onClick={() => viewRevisionHistory()} color="primary" fontSize="small" />
            </Tooltip>
          </li>
          <li className="list-inline-item">
            <Tooltip title="View" arrow>
              <VisibilityIcon onClick={() => viewQmeTracker()} color="primary" fontSize="small" />
            </Tooltip>
          </li>
          {item?.permissions?.update ?
            <li className="list-inline-item">
              <Tooltip title="Edit" arrow>
                <EditIcon onClick={() => editQmeTracker()} color="primary" fontSize="small" />
              </Tooltip>
            </li> : null
          }
        </ul>
      </Cell>
      <Cell index={1}>
        {item?.project_slug ?
          <>
            <Link to={`/technical/project/view/${item?.project_slug}`}><span className="project-no">{item?.project_number !== null && item?.project_number !== undefined ? `#${item?.project_number}` : '--'}</span></Link>
            <br />
            <h4 className="project-name">{item?.name || '--'}</h4>
          </> : '--'
        }
      </Cell>
      <Cell index={2}>{item.sysco_claim_number || '--'}</Cell>
      <Cell index={3}>
        <ChipList items={item.msn} />
      </Cell>
      <Cell index={4}>{item.location || '--'}</Cell>
      <Cell index={5}>
        <ChipList items={item.component_serial_numbers} getLabel={formatComponentSerial} />
      </Cell>
      <Cell index={6}>{item.mro_facility || '--'}</Cell>
      <Cell index={7}>{item.lessee?.name || '--'}</Cell>
      <Cell index={8}>{item.qme_type || '--'}</Cell>
      <Cell index={9}><LongText text={item.workscope} /></Cell>
      <Cell index={10}>
        <ChipList items={item.assigned_to} getLabel={user => user.name} />
      </Cell>
      <Cell index={11}>{item.start_date ? moment(item.start_date).format(displayDateFormatShort) : '--'}</Cell>
      <Cell index={12}>{item.target_date ? moment(item.target_date).format(displayDateFormatShort) : '--'}</Cell>
      <Cell index={13}><span className={`project-status ${status?.className || ''}`}><span>{item.tracker_status?.label || '--'}</span></span></Cell>
      <Cell index={14}>
        {item.tracker_progress !== null && item.tracker_progress !== undefined ? <div className="qme-progress"><LinearProgress variant="determinate" value={item?.tracker_progress} /><span>{item?.tracker_progress}%</span></div> : '--'}
      </Cell>
      <Cell index={15}>{item.last_updated ? moment.utc(item.last_updated).local().format(qmeDateTimeFormat) : '--'}</Cell>
      <Cell index={16}><LongText text={item.next_action} /></Cell>
      <Cell index={17}><LongText text={item.vendor_remarks} /></Cell>
      <Cell index={18}><LongText text={item.client_remarks} /></Cell>
    </TableRow>
  )
}
